module.exports = __webpack_public_path__ + "img/circle.311cc090.png";